// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import CommonLayout from './../../components/CommonLayout';
import { PrimaryButton } from 'office-ui-fabric-react';

import Styles from './packageInstructions.module.scss';
import { logPageAction } from './../../lib/ApplicationInsights';

function Body () {
    const { t } = useTranslation();

    function onClose () {
        logPageAction('Close button clicked');
        window.close();
    }

    return (
        <div className={Styles.body}>
            <div className={Styles.title}>{t('instructions_for_packaging_title')}</div>
            <Instructions />
            <PrimaryButton
                className={Styles.closeButton}
                onClick={onClose}
                text={t('close')}
                aria-label={t('close_package_instructions')}
            />
        </div>
    );
}

function Instructions () {
    const { t } = useTranslation();

    return (
        <section className={Styles.section}>
            <ol className={Styles.steps}>
                <li>
                    {t('backup_your_surface')}
                    {<RenderBackupSurface />}
                </li>
                
                <li>
                    {t('pack_and_ship_your_device')}
                    <RenderPackAndShip />
                </li>
                
            </ol>
        </section>
    );
}

export default function PackageInstructions () {
    const { t } = useTranslation();
    return (
        <CommonLayout
            hideBreadcrumb={true}
            pageTitle={[t('package_instructions')]}
        >
            <Body />
        </CommonLayout>
    );
}

function RenderBackupSurface () {
    const { t } = useTranslation();

    const src = `https://support.microsoft.com/help/4023529/surface-how-to-prepare-your-surface-for-service`;

    const bullets = [];
    for(let i=1; i<= 3; i++) {
        bullets.push(<li key={i.toString()}>{t(`backup_your_surface_step_${i}`)}</li>);
    }

    function onClickLink() {
        logPageAction('How to get your surface ready for service link clicked');
    }

    return (
        <ul className={Styles.bullets}>
            {bullets}
            <li>{t('backup_your_surface_step_4')}&nbsp;<a onClick={onClickLink} href={src} target="_blank">{t('get_surface_ready')}</a>.</li>
        </ul>
    );
}

function RenderPackAndShip () {
    const { t } = useTranslation();

    const bullets = [];
    for(let i=1; i<= 7; i++) {
        bullets.push(<li key={i.toString()}>{t(`pack_and_ship_your_device_step_${i}`)}</li>);
    }

    return (
        <section className={Styles.secondSection}>
            <span className={Styles.secondBulletLabel}>{t('here_is_what_you_need_to_know')}</span>
            <ul className={Styles.secondBullet}>
                {bullets}
            </ul>
        </section>
    );
}